import { useEffect, useState } from 'react';
import DraggableList from 'react-draggable-list';
import { StandardComp } from '../atoms/standardComp';

export const OrderAnswers = ({answers, updateOrder1}) => {   
    const [dragAnswers, updateDragAnswers] = useState(answers)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;
      useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
      }, []);
    const handleAnswersChange = (newAnswers) => {
      updateDragAnswers(newAnswers);
      console.log(newAnswers)
      updateOrder1(newAnswers);
    };
    console.log(answers)
    const AnswerTemplate = ({ item, dragHandleProps, itemSelected }) => (
  
        <div className={`dragHandle no-padding`} {...dragHandleProps}>
            <StandardComp
            editClass={`${itemSelected !== 0 ? "active-standard" : ""}`} style={{"transition": "0.3s"}}
            content={
                <div className="horizontal multiplechoice-button">
                    <p className="standard-text-color">{item.text}</p>
                </div>
            }
            />
        </div>
      );
    
      return (
        <div>
            <DraggableList
              itemKey="inputID"
              template={AnswerTemplate}
              list={dragAnswers}
              onMoveEnd={handleAnswersChange}
            />
          </div>
      );
}